export default "__VITE_ASSET__d6d5b23d__"